// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fabricationModal_modal-box__B4yfn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 500px;
  background-color: var(--secondary-color);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(245, 242, 242, 0.2);
  padding: 16px;
  width: auto; /* Default */
}

@media (max-width: 600px) {
  .fabricationModal_modal-box__B4yfn {
    width: 90%; /* Override for mobile */
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/fabricationModal.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,WAAW,EAAE,YAAY;AAC3B;;AAEA;EACE;IACE,UAAU,EAAE,wBAAwB;EACtC;AACF","sourcesContent":[".modal-box {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-width: 500px;\n  background-color: var(--secondary-color);\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(245, 242, 242, 0.2);\n  padding: 16px;\n  width: auto; /* Default */\n}\n\n@media (max-width: 600px) {\n  .modal-box {\n    width: 90%; /* Override for mobile */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-box": `fabricationModal_modal-box__B4yfn`
};
export default ___CSS_LOADER_EXPORT___;
